"use strict";

import Nominatim from "./Nominatim";
import api from "./../api";

export default (function(){
	
	var geocoder = null;
	var nominatim = null;
	
	function initGeocoder() {
		if (!google || !google.maps || !google.maps.Geocoder)
			throw new Error("Missing requirement: google.maps.Geocoder");
		if (geocoder)
			return;
		geocoder = new google.maps.Geocoder();
	}
	
	function initNominatim() {
		if (!Nominatim)
			throw new Error("Missing requirement: Nominatim");
		if (nominatim)
			return;
		nominatim = new Nominatim();
	}
	
	function isGeoPoint(request) {
		if (request.constructor !== Object)
			return false;
		if (!request.type || request.type !== 'Point')
			return false;
		if (!request.coordinates || request.coordinates.constructor !== Array)
			return false;
		if (request.coordinates.length !== 2)
			return false;
		return true;
	}
	
	function latLngToPoint(latLng) {
		return {
			type: "Point",
			coordinates: [latLng.lng(), latLng.lat()]
		};
	}
		
	/**
		@param {String} [engine=google]
		@param {google.maps.LatLng | String} request In the case of string, this is the requested address
		@param {geocoder~callback} [callback]
	*/
	
	function geocode(engine, request, callback) {
		
		engine = engine || "google";
		callback = callback || ((err, result) => {});
		
		if (!request)
			return;
		if (engine === 'google')
			initGeocoder();
		else if (engine === 'nominatim')
			initNominatim();
		if (request.constructor === String) {
			return geocodeAddress(request, callback);
		}
		else if (request.constructor === google.maps.LatLng) {
			return geocodePosition(engine, request, callback);
		}
		else if (isGeoPoint(request)) {
			return geocodePosition(engine, new google.maps.LatLng(request.coordinates[1], request.coordinates[0]), callback);
		}
	}
	
	/**
		@callback geocoder~callback
			@param {Error} error
			@param {String|google.maps.LatLng} result
	*/
	
	function geocodePosition(engine, position, callback) {
		
		callback = callback || ((error, address) => {});
		
		return new Promise((resolve, reject) => {
			if (engine === 'google') {
				geocoder.geocode({location: position}, function(results, status){
					if (status == google.maps.GeocoderStatus.OK && results.length) {
						try {
							api.storeAddress(latLngToPoint(position), results[0].formatted_address);
						} catch (error) {}
						callback(null, results[0].formatted_address);
						resolve(results[0].formatted_address);
					}
					else {
						const error = new Error(status);
						callback(error);
						reject(error);
					}
				});
			}
			else if (engine === 'nominatim') {
				nominatim.geocode(position, function(error, address){
					if (error) {
						callback(error);
						return;
					}
					try {
						api.storeAddress(latLngToPoint(position), address);
					} catch (error) {}
					callback(null, address);
					resolve(address);
				});
			}
		});
	}
	
	function geocodeAddress(address, callback) {
		
		callback = callback || ((error, position) => {});
		
		return new Promise((resolve, reject) => {
			geocoder.geocode({address: address}, function(results, status){
				if (status == google.maps.GeocoderStatus.OK) {
					if (results.length) {
						callback(null, results[0].geometry.location);
						resolve(results[0].geometry.location);
					}
					else {
						const error = new Error("No results");
						callback(error, null);
						reject(error);
					}
				}
				else {
					const error = new Error("GeocoderStatus: "+status);
					callback(error, null);
					reject(error);
				}
			});
		});
	}
	
	return geocode;
	
})();


// WEBPACK FOOTER //
// ./~/vwa/geocode/index.js